import React, { useState, useEffect } from "react";
import { AvField } from 'availity-reactstrap-validation'
import ReactDatePicker, { registerLocale, subDays } from "react-datepicker";
import id from "date-fns/locale/id";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
registerLocale("id", id);

const DatePicker = (props) => {
    const [compValue, setCompValue] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [pMinDate, setPMinDate] = useState(null);
    const [pMaxDate, setPMaxDate] = useState(null);
    const [pExcludeDates, setpExcludeDates] = useState(null);
    const weekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    };

    const {
        name,
        errorMessage,
        defaultValue = null,
        validate,
        onChange = null,
        placeholder = "dd/mm/yyyy",
        isAvForm = true,
        dateFormat = "dd/MM/yyyy",
        selected = new Date(),
        isWeekday = true,
        minDate = null,
        maxDate = null,
        excludeDates = null,
    } = props

    useEffect(() => {
        try {
            if (defaultValue) {
                setCompValue(moment(defaultValue).format('YYYY-MM-DD'))
                setSelectedDate(new Date(defaultValue))
            } else if (defaultValue === null || defaultValue === '') {
                setCompValue('')
                setSelectedDate(null)
            }
        } catch (error) {
            console.log(error)
        }
    }, [defaultValue])

    useEffect(() => {
        try {
            setPMinDate(minDate ? new Date(minDate) : null)
        } catch (error) {
            console.log(error)
        }
    }, [minDate])

    useEffect(() => {
        try {
            setPMaxDate(maxDate ? new Date(maxDate) : null)
        } catch (error) {
            console.log(error)
        }
    }, [maxDate])

    useEffect(() => {
        try {
            setpExcludeDates(excludeDates || null)
        } catch (error) {
            console.log(error)
        }
    }, [excludeDates])

    const handleChange = (data) => {
        setCompValue(data ? moment(data).format('YYYY-MM-DD') : '')
        setSelectedDate(data)
        if (onChange) {
            onChange(data)
        }
    }

    return (
        <>
            <ReactDatePicker 
                wrapperClassName="w-100 d-block"
                selected={selectedDate} 
                placeholderText={placeholder}
                onChange={handleChange}
                className="form-control"
                filterDate={isWeekday ? weekday : null}
                dateFormat={dateFormat}
                locale="id"
                minDate={pMinDate}
                maxDate={pMaxDate}
                excludeDates={pExcludeDates}
                showMonthDropdown
                showYearDropdown
                dayClassName={(date) => {
                    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
                    const isHoliday = pExcludeDates && pExcludeDates.some(d => new Date(d).toDateString() === date.toDateString());
                    return (isWeekend || isHoliday) ? "text-danger" : undefined;
                }}
            />

            {isAvForm &&
                <AvField
                    errorMessage={errorMessage}
                    name={name}
                    type="hidden"
                    value={compValue}
                    validate={validate}
                />
            }
        </>
    )
}

export default DatePicker